import { GET, POST } from '@/shared/api/requests';
import { Client } from '@/types/base';
import { CreateLayoutRequest, CreateLayoutResponse, ProjectOption } from '../types';

/**
 * Get all clients (staff only)
 */
export const getClients = async (hasActiveProjects: boolean = true): Promise<Client[]> => {
  const response = await GET(`/base/clients/?has_active_projects=${hasActiveProjects}`);
  return response.data;
};

/**
 * Get projects for a specific client
 */
export const getProjectsForClient = async (
  clientId: number,
  activeOnly: boolean = true
): Promise<ProjectOption[]> => {
  const response = await GET(`/projects-for-client/?client_id=${clientId}&active_only=${activeOnly}`);
  return response.data;
};

/**
 * Get available layout types
 */
export const getLayoutTypes = async (): Promise<string[]> => {
  // Return the standard layout types
  return ['Progress', 'Asbuild', 'Corridor'];
};

/**
 * Create a new layout
 */
export const createLayout = async (data: CreateLayoutRequest): Promise<CreateLayoutResponse> => {
  const response = await POST('/layouts/create/', data);
  return response.data;
};

